import { combineReducers } from "redux";
import { sidebarStatus } from "./constants";

import axios from "axios";

// action types

export const TOGGLE_LAYOUT_SIDEBAR = "TOGGLE_LAYOUT_SIDEBAR";
export const SHOW_LAYOUT_SIDEBAR = "SHOW_LAYOUT_SIDEBAR";
export const HIDE_LAYOUT_SIDEBAR = "HIDE_LAYOUT_SIDEBAR";
export const GET_BACKEND_VERSION = "GET_BACKEND_VERSION ";
// action creators

export const toggleLayoutSidebar = () => ({
  type: TOGGLE_LAYOUT_SIDEBAR,
});

export const showLayoutSidebar = () => ({
  type: SHOW_LAYOUT_SIDEBAR,
});

export const hideLayoutSidebar = () => ({
  type: HIDE_LAYOUT_SIDEBAR,
});

export const getBackendVersion = () => (dispatch) => {
  axios
    .get(`/api/version`)
    .then((r) => {
      let v = r.data?.version;
      return dispatch({ type: GET_BACKEND_VERSION, backendVersion: v });
    })
    .catch(() => {});
};

// selectors

const getModuleData = (state) => state.layout;

export const isSidebarCollapsed = (state) =>
  getModuleData(state).sidebar.status === sidebarStatus.collapsed;
export const isSidebarExpanded = (state) =>
  getModuleData(state).sidebar.status === sidebarStatus.expanded;
export const isSidebarVisible = (state) =>
  getModuleData(state).sidebar.status !== sidebarStatus.hidden;
export const getVersionBackend = (state) =>
  getModuleData(state).footer.backendVersion;
// mappings

export const mapStateToPropsLayout = (state) => ({
  isSidebarCollapsed: isSidebarCollapsed(state),
  isSidebarExpanded: isSidebarExpanded(state),
  isSidebarVisible: isSidebarVisible(state),
});

export const mapStateToPropsFooter = (state) => ({
  backendVersion: getVersionBackend(state),
});

export const mapDispatchToPropsLayout = {
  toggleLayoutSidebar,
  showLayoutSidebar,
  hideLayoutSidebar,
  getBackendVersion,
};

// reducers

const sidebarInitialState = {
  status: sidebarStatus.expanded,
};

const sidebarReducer = (state = sidebarInitialState, action) => {
  switch (action.type) {
    case TOGGLE_LAYOUT_SIDEBAR:
      return {
        ...state,
        status:
          state.status === sidebarStatus.collapsed
            ? sidebarStatus.expanded
            : sidebarStatus.collapsed,
      };

    case SHOW_LAYOUT_SIDEBAR:
      return {
        ...state,
        status: sidebarStatus.collapsed,
      };

    case HIDE_LAYOUT_SIDEBAR:
      return {
        ...state,
        status: sidebarStatus.hidden,
      };

    default:
      return state;
  }
};

const footerInitialState = {
  backendVersion: "0.0.0",
};
const footerReducer = (state = footerInitialState, action) => {
  switch (action.type) {
    case GET_BACKEND_VERSION: {
      return {
        ...state,
        backendVersion: action.backendVersion,
      };
    }

    default:
      return state;
  }
};

export default combineReducers({
  sidebar: sidebarReducer,
  footer: footerReducer,
});
